import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'

export const StyledMessageFooter = styled.div(
    ({theme: {spacing, palette}}) => css`
        flex-shrink: 0;
        width: 100%;
        padding: ${spacing * 3}px;
        background-color: ${palette.neutral.white};
        border-top: 1px solid ${palette.neutral[100]};
    `
)

export const StyledMessageForm = styled.form(
    ({theme: {spacing, typography, palette}}) => css`
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        & div {
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
        }
        & textarea {
            padding: ${spacing * 2}px;
            ${typography.textXs};
        }
    `
)

export const StyledFormActions = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: 0 ${spacing * 3}px ${spacing * 2}px;
    `
)

export const StyledUrgentButton = styled(Button)<{$isActive?: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        color: ${$isActive ? palette.warning[600] : palette.neutral[500]};
        &:hover {
            color: ${$isActive ? palette.warning[700] : palette.warning[600]};
        }
    `
)
